import { fetcher } from '@commenda/utils';
import { ICommendaProduct } from './types';

type CreateSalesTaxProductsProps = {
  name: string;
  tax_code: string;
  description?: string;
  sku: string;
};

type ProductResult = {
  success: boolean;
  data?: ICommendaProduct;
  error?: string;
};

export async function createSalesTaxProduct(
  body: CreateSalesTaxProductsProps,
  token: string,
  corporationId: number
): Promise<ProductResult> {
  try {
    const response = await fetcher(
      `new-sales-tax/products/corporation/${corporationId}`,
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error creating product:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to create product',
      };
    }

    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create product';
    console.error('Failed to create product:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}
